import React, { useContext } from 'react'
import { AnimatePresence } from 'framer-motion';
import { motion } from 'framer-motion';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { Button, Segment } from 'semantic-ui-react';

const PagePrompt = () => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appInstallation } = aps_global ?? {}
  const { addToHomeScreenText, allowAppInstallation, allowAutoPromptForAppIntallation, allowManualAppInstallation, showAddToHomeScreenHelp } = appInstallation ?? {}

  return (
    <AnimatePresence>
      <motion.div
        className="app-badge"
        initial={{ opacity: 0, y: 30, scale: 0.9 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 30, scale: 0.9 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <Segment basic size='small'>
          This app works better when installed on your device!
        </Segment>
        {/* <Button.Group attached='bottom'>
          <Button color='red'>Cancel</Button>
          <Button color='green'>{'Add to Homescreen'}</Button>
        </Button.Group> */}
      </motion.div>
    </AnimatePresence>
  )
}

export default PagePrompt 